module.exports = __webpack_public_path__ + "img/statistics-bg-4.a42fcd06.png";